// 引入公共模块
import { 
  mergeParams,
  addParamsToLinksHandler,
  pageJumpHandler,
  pageJumpBlankHandler,
  initScrollHandler,
  initNavBarHandler,
} from './common.js';

// 命名空间模式
const App = {
  init() {
    addParamsToLinksHandler(mergeParams()); //为链接添加参数
    pageJumpHandler(); //页面跳转
    pageJumpBlankHandler(); // 页面跳转(新窗口打开)
    initScrollHandler(); // 滚动处理
    initNavBarHandler(); // 导航下拉处理
    this.animateHandler(); // 动画处理
  },
  animateHandler() {
    const $containers = $('.prod-item-container');
    const observer = new IntersectionObserver(function (entries) {
      $.each(entries, function (_, entry) {
        const $box = $(entry.target);
        // 完全离开视口：重置动画
        if (!entry.isIntersecting) {
          $box.removeClass('show-animate');
        } else {
          // 进入视口：播放动画
          $box.addClass('show-animate');
        }
      });
    }, {
      threshold: [0, 0.2]
    });

    $containers.each(function () {
      observer.observe(this);
    });
  }
};

// 文档加载后初始化
$(function () {
  App.init();
});
